// extracted by mini-css-extract-plugin
module.exports =  {"diff":"AnswerDiff-ENGO__diff","diff--incorrect":"AnswerDiff-Nau9__diff--incorrect","diff--missing":"AnswerDiff-IFFU__diff--missing"};